import React, {useEffect} from 'react';
import {Table} from 'antd';
import PropTypes from "prop-types";
import {ceil, isFunction} from "lodash";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

//inventoryFilterByVendor

/**
 *
 * @description LoadMoreAction({current, pageSize, total}) can be null
 */
const AntDataGrid = ({
                         data = [], columns = [], isLoading = false,
                         ToolBar = null, doubleClickAction = null,
                         loadMoreAction = null, onPageChange, pageSize = null,
                         size = 'small',
                         shadows = false,
                         Currency = ""
                     }) => {

    const [selected, setSelected] = React.useState([]);
    const [pagination, setPagination] = React.useState({current: 1, pageSize: pageSize ? pageSize : 10});
    useEffect(() => {
        return () => {
            setSelected([])
        };
    }, [isLoading]);


    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelected(selectedRows);
    };

    // console.log("loadMoreAction = ", loadMoreAction)


    const rowSelection = {
        selected,
        onChange: onSelectChange,
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE,
            {
                key: 'odd',
                text: 'Select Odd Row',
                onSelect: changableRowKeys => {
                    let newSelectedRowKeys = [];
                    newSelectedRowKeys = changableRowKeys.filter((key, index) => {
                        if (index % 2 !== 0) {
                            return false;
                        }
                        return true;
                    });
                    setSelected(newSelectedRowKeys);
                },
            },
            {
                key: 'even',
                text: 'Select Even Row',
                onSelect: changableRowKeys => {
                    let newSelectedRowKeys = [];
                    newSelectedRowKeys = changableRowKeys.filter((key, index) => {
                        if (index % 2 !== 0) {
                            return true;
                        }
                        return false;
                    });
                    setSelected(newSelectedRowKeys);
                },
            },
        ],
    };

    const handleRow = (record, rowIndex) => {
        return {
            onDoubleClick: event => {
                if (doubleClickAction !== null) {
                    console.log(record, rowIndex)
                    doubleClickAction(record)
                }
            }
        };
    }

    const handleTableChange = (_pagination, filters, sorter) => {
        if (loadMoreAction !== null) {
            loadMoreAction({..._pagination, total: data.length +1})
        }

        // console.log(data.length + 1 )

        isFunction(onPageChange) && onPageChange(_pagination.current, ceil(data.length / _pagination.pageSize))
        setPagination({..._pagination, total: (data.length +1)})

        // console.log(data)
        // console.log(data.length )
        // console.log( ceil(data.length / _pagination.pageSize))
        // console.log(_pagination.pageSize )
        // console.log(_pagination.current )
        // console.log(_pagination.total )
        // console.log(_pagination )
    }


    return (
        <div>

            {ToolBar && <ToolBar numSelected={selected.length} setSelected={setSelected} selectedItem={selected} data={data} Currency={Currency}/>}
            <Card style={{boxShadow: shadows ? 15 : 'none', borderRadius: 20}}>
                <CardContent style={{padding: 0}}>
                    <Table loading={isLoading ?? false }
                           onRow={handleRow}
                           onChange={handleTableChange}
                           rowSelection={rowSelection}
                           columns={columns}
                           pagination={pagination}
                           dataSource={data } size={size}/>
                </CardContent>
            </Card>
        </div>
    )
}

AntDataGrid.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    ToolBar: PropTypes.any,
    doubleClickAction: PropTypes.func,
    //oneClickAction: PropTypes.func,
}

export default AntDataGrid
